(() => {
  const videos = document.querySelectorAll('.section-full-width-banner__media video, .section-carousel__media video');
  if (!videos.length || !('IntersectionObserver' in window)) return;
  const observer = new IntersectionObserver(entries => {
    entries.forEach(({ target, isIntersecting }) => {
      if (isIntersecting) {
        if (target.preload === 'none') target.preload = 'auto';
        target.play().catch(() => {});
      } else if (!target.paused) {
        target.pause();
      }
    });
  }, { rootMargin: '200px 0px' });
  videos.forEach(video => observer.observe(video));
})();
